/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { piDependencies } from './dependenciesPi.generated';
import { createUppercasePi } from '../../factoriesAny.js';
export var PIDependencies = {
  piDependencies: piDependencies,
  createUppercasePi: createUppercasePi
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesUppercasePi.generated.js
// module id = 1679
// module chunks = 0